
Checkout.Remote = function(checkout) {
	var remote = this;

	this.settings = {
		'url': checkout.config.endpoint,
		'cache': false,
		'type': 'GET',
		'dataType': 'json',
		'data': {
			'version': checkout.config.version,
		},
		'dataFilter': function(data) {
			if (!data)
				return 'Empty Response'

			return data;
		}
	};

	this.call = function(settings) {
		return $.ajax($.extend(true, $.extend(true, {}, remote.settings), settings))
			.fail(function(request) {
				var errorMsg = remote.getErrorMsg(request);

				if (
					errorMsg
					&& errorMsg == 'version mismatch'
					&& confirm('Checkout is out of date. Page must be refreshed')
				) {
					location.reload(true);
					return;
				}

			});
	};

	// Util to extract the error message from a failed request
	this.getErrorMsg = function(request) {

		if (request.status == 500)
			return 'Internal Server Error';

		if (request.status == 404)
			return 'Server Not Found';

		if (
			request.status == 200
			&& request.getResponseHeader('content-type').split(';')[0].toLowerCase() == 'text/plain'
		)
			return (request.responseText || 'Unknown Response Type');

		// request.status == 0 (canceled)

		return false;
	};
};
